import React from "react";

const EnglishQuizNavigation = ({
  questions = [],
  currentIndex = 0,
  answers = {},
  onQuestionChange,
  onPrevious,
  onNext,
  onSubmit,
  isSubmitting = false,
}) => {
  const isAnswered = (questionId) => {
    const answer = answers[questionId];

    if (answer === null || answer === undefined) {
      return false;
    }

    if (
      typeof answer === "string" &&
      !answer.trim()
    ) {
      return false;
    }

    if (
      Array.isArray(answer) &&
      answer.length === 0
    ) {
      return false;
    }

    return true;
  };

  if (!questions.length) {
    return null;
  }

  const isFirstQuestion = currentIndex === 0;
  const isLastQuestion =
    currentIndex === questions.length - 1;

  return (
    <div className="mt-6 rounded-2xl bg-white p-5 shadow">

      {/* Question Numbers */}

      <div className="flex flex-wrap gap-2">
        {questions.map((question, index) => {
          const answered = isAnswered(
            question._id,
          );

          const current =
            index === currentIndex;

          return (
            <button
              key={question._id}
              type="button"
              onClick={() =>
                onQuestionChange(index)
              }
              className={`
                h-9
                w-9
                rounded-lg
                text-sm
                font-semibold
                border
                ${
                  current
                    ? "bg-blue-600 text-white border-blue-600"
                    : answered
                      ? "bg-green-100 text-green-700 border-green-300"
                      : "bg-gray-100 text-gray-600 border-gray-200"
                }
              `}
            >
              {index + 1}
            </button>
          );
        })}
      </div>

      {/* Navigation Buttons */}

      <div className="mt-5 flex items-center justify-between gap-3">

        <button
          type="button"
          onClick={onPrevious}
          disabled={isFirstQuestion}
          className="
            rounded-xl
            border
            border-gray-300
            px-5
            py-2.5
            font-semibold
            text-gray-700
            hover:bg-gray-50
            disabled:cursor-not-allowed
            disabled:opacity-40
          "
        >
          Previous
        </button>

        {!isLastQuestion ? (
          <button
            type="button"
            onClick={onNext}
            className="
              rounded-xl
              bg-blue-600
              px-5
              py-2.5
              font-semibold
              text-white
              hover:bg-blue-700
            "
          >
            Next
          </button>
        ) : (
          <button
            type="button"
            onClick={onSubmit}
            disabled={isSubmitting}
            className="
              rounded-xl
              bg-green-600
              px-5
              py-2.5
              font-semibold
              text-white
              hover:bg-green-700
              disabled:cursor-not-allowed
              disabled:opacity-50
            "
          >
            {isSubmitting
              ? "Submitting..."
              : "Submit Quiz"}
          </button>
        )}

      </div>
    </div>
  );
};

export default EnglishQuizNavigation;